<template>
  <el-input
    v-model.trim="thousandsNumber"
    :maxlength="maxlength"
    :minlength="minlength"
    :placeholder="placeholder"
    :value="value"
    :size="size"
    :resize="resize"
    :form="form"
    :disabled="disabled"
    :autosize="autosize"
    :autocomplete="autocomplete"
    :showPassword="showPassword"
    :prefixIcon="prefixIcon"
    :suffixIcon="suffixIcon"
    :label="label"
    :clearable="clearable"
    :validateEvent="validateEvent"
    :showWordLimit="showWordLimit"
    :tabindex="tabindex"
    @input="handleInput($event)"
    @focus="handleFocus($event)"
    @change="handleChange($event)"
    @blur="handleBlur($event)"
  >
  </el-input>
</template>
<script>
  export default {
    name: 'ArtThousandsInput',
    componentName: 'ArtThousandsInput',
    data() {
      return {
        thousandsNumber: ''
      };
    },

    props: {
      model: [String, Number],
      value: [String, Number],
      minlength: [String, Number],
      maxlength: [String, Number],
      placeholder: String,
      // 允许输入负数
      minus: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      disabled: Boolean,
      size: String,
      suffixIcon: String,
      prefixIcon: String,
      autosize: {
        type: [Boolean, Object],
        default: false
      },
      autocomplete: {
        type: String,
        default: 'off'
      },
      /** @Deprecated in next major version */
      autoComplete: {
        type: String,
        validator(val) {
          process.env.NODE_ENV !== 'production' &&
          console.warn('[Element Warn][Input]\'auto-complete\' property will be deprecated in next major version. please use \'autocomplete\' instead.');
          return true;
        }
      },
      name: String,
      readonly: Boolean,
      resize: String,
      form: String,
      validateEvent: {
        type: Boolean,
        default: true
      },
      label: String,
      showPassword: {
        type: Boolean,
        default: false
      },
      showWordLimit: {
        type: Boolean,
        default: false
      },
      tabindex: String
    },

    computed: {
    },

    watch: {
      model: {
        deep: true,
        immediate: true,
        handler (val, oldVal) {
          let newVal = this.getInputValue(val, true)
          this.thousandsNumber = [null, undefined, ''].includes(val) ? '' : newVal;
        }
      }
    },

    methods: {
      /**
       * 获取输入框的值
       * */
      getInputValue (el, flag) {
        let inputVal = flag ? el : (el.target.value || '');
        let value = Number(this.$utils.delcommafy(inputVal)).toFixed(2);
        return this.$utils.comdify(value);
      },
      // 输入
      handleInput (el) {
        this.accountInput(el)
        this.$emit('input', el)
      },
      // 获取焦点
      handleFocus (el) {
        this.accountInput(el, true)
        this.$emit('focus', el)
      },
      // 失去焦点
      handleBlur (el) {
        this.inputMoney(el)
        this.$emit('blur', el)
      },
      // 改变
      handleChange (el) {
        this.inputMoney(el, true)
        this.$emit('change', el)
      },
      /**
       * 获取焦点 输入时
       * */
      accountInput (el, flag) {
        let inputVal = flag ? (el.target.value || '') : el;

        let minusReg = new RegExp("[0-9|.\-]+");
        let positiveNumReg = new RegExp("[0-9|.]+");
        let codeReg = this.minus ? minusReg : positiveNumReg;

        let len = inputVal.length;
        let str = '';

        for(let i=0; i<len; i++){
          if( codeReg.test(inputVal[i]) ){
            str += inputVal[i]
          }
        }
        this.thousandsNumber = [null, undefined, ''].includes(str) ? '' : str;
      },
      /**
       * 失焦时
       * */
      inputMoney (el, flag) {
        let val = el ? this.getInputValue(el, flag) : ''
        this.thousandsNumber = [null, undefined, ''].includes(val) ? '' : val;
        this.$emit('update:model', this.$utils.delcommafy(this.thousandsNumber));
      }
    },

    created() {

    },

    mounted() {

    },

    updated() {

    }
  };
</script>



// WEBPACK FOOTER //
// src/components/common/el/art-thousands-input/index.vue